module.exports = __webpack_public_path__ + "static/media/message.968ec1d0.svg";